export const response_factura_find = {
  descripcion: 'Factura encontrada exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string' },
      data: {
        type: 'object',
        properties: {
          id: { type: 'string', format: 'uuid' },
          empresa_id: { type: 'string', format: 'uuid' },
          cliente_id: { type: 'string', format: 'uuid' },
          tipo_transaccion_id: { type: 'string', format: 'uuid', nullable: true },
          tipo_impuesto_id: { type: 'string', format: 'uuid', nullable: true },
          moneda_id: { type: 'string', format: 'uuid', nullable: true },
          indicador_presencia_id: { type: 'string', format: 'uuid', nullable: true },
          condicion_operacion_id: { type: 'string', format: 'uuid', nullable: true },
          tipo_operacion_id: { type: 'string', format: 'uuid', nullable: true },
          sucripcion_id: { type: 'string', format: 'uuid', nullable: true },
          dinfoemi: { type: 'string', nullable: true },
          dinfofisc: { type: 'string', nullable: true },
          dest: { type: 'string' },
          dpunexp: { type: 'string' },
          dnumdoc: { type: 'string' },
          dserienum: { type: 'string', nullable: true },
          dfeemide: { type: 'string', format: 'date-time' },
          dcondticam: { type: 'string', nullable: true },
          dticam: { type: 'number', nullable: true },
          icondant: { type: 'string', nullable: true },
          dfecemnr: { type: 'string', format: 'date-time', nullable: true },
          demailadmin: { type: 'string', nullable: true },
          dmodcont: { type: 'string', nullable: true },
          dentcont: { type: 'number', nullable: true },
          danocont: { type: 'number', nullable: true },
          dseccont: { type: 'string', nullable: true },
          dfecodcont: { type: 'string', format: 'date-time', nullable: true },
          dciclo: { type: 'string', nullable: true },
          dfecinic: { type: 'string', format: 'date-time', nullable: true },
          dfecfinc: { type: 'string', format: 'date-time', nullable: true },
          dvencpag: { type: 'string', format: 'date-time', nullable: true },
          dcontrato: { type: 'string', format: 'date-time', nullable: true },
          dsalant: { type: 'number', nullable: true },
          dinfadic: { type: 'string', nullable: true },
          icondcred: { type: 'number', nullable: true },
          dplazocre: { type: 'string', nullable: true },
          dcuotas: { type: 'number', nullable: true },
          dmonent: { type: 'number', nullable: true },
          estado: { type: 'string' },
          documentos_asociados: { type: 'object', nullable: true },
          created_at: { type: 'string', format: 'date-time', nullable: true },
          updated_at: { type: 'string', format: 'date-time', nullable: true },
          usuario: { type: 'string', nullable: true },
          cuentas_cobrar: { type: 'array', items: { type: 'object' } },
          clientes: {
            type: 'object',
            nullable: true,
            properties: {
              id: { type: 'string', format: 'uuid' },
              persona_id: { type: 'string', format: 'uuid' },
              tipo_operacion_id: { type: 'string', format: 'uuid' },
              nombre_fantasia: { type: 'string', nullable: true },
              cod_cliente: { type: 'string', nullable: true },
              active: { type: 'boolean' },
              deleted: { type: 'boolean' },
              deleted_at: { type: 'string', format: 'date-time', nullable: true },
              created_at: { type: 'string', format: 'date-time', nullable: true },
              updated_at: { type: 'string', format: 'date-time', nullable: true },
              usuario: { type: 'string', nullable: true },
              personas: {
                type: 'object',
                nullable: true,
                properties: {
                  id: { type: 'string', format: 'uuid' },
                  empresa_id: { type: 'string', format: 'uuid', nullable: true },
                  tipo_documento_id: { type: 'string', format: 'uuid', nullable: true },
                  ciudad_id: { type: 'string', format: 'uuid', nullable: true },
                  naturaleza_id: { type: 'string', format: 'uuid', nullable: true },
                  tipo_contribuyente_id: { type: 'string', format: 'uuid', nullable: true },
                  razon_social: { type: 'string', nullable: true },
                  direccion: { type: 'string', nullable: true },
                  nro_casa: { type: 'number', nullable: true },
                  telefono: { type: 'string', nullable: true },
                  celular: { type: 'string', nullable: true },
                  email: { type: 'string', nullable: true },
                  ruc: { type: 'string', nullable: true },
                  dv: { type: 'string', nullable: true },
                  nro_documento: { type: 'string', nullable: true },
                  otro_tipo_documento: { type: 'string', nullable: true },
                  email_copia: { type: 'string', nullable: true },
                  email_adicional: { type: 'string', nullable: true },
                  active: { type: 'boolean', nullable: true },
                  deleted: { type: 'boolean', nullable: true },
                  deleted_at: { type: 'string', format: 'date-time', nullable: true },
                  estado: { type: 'string', nullable: true },
                  created_at: { type: 'string', format: 'date-time', nullable: true },
                  updated_at: { type: 'string', format: 'date-time', nullable: true },
                  usuario: { type: 'string', nullable: true },
                },
              },
            },
          },
          condicion_operacion: {
            type: 'object',
            nullable: true,
            properties: {
              id: { type: 'string', format: 'uuid' },
              codigo: { type: 'number' },
              descripcion: { type: 'string', nullable: true },
              created_at: { type: 'string', format: 'date-time', nullable: true },
              updated_at: { type: 'string', format: 'date-time', nullable: true },
              usuario: { type: 'string', nullable: true },
            },
          },
          empresas: {
            type: 'object',
            nullable: true,
            properties: {
              id: { type: 'string', format: 'uuid' },
              ruc: { type: 'string' },
              dv: { type: 'string' },
              razon_social: { type: 'string', nullable: true },
              nombre_fantasia: { type: 'string', nullable: true },
              tipo_contribuyente: { type: 'string', format: 'uuid', nullable: true },
              type: { type: 'string', nullable: true },
              parent_id: { type: 'string', format: 'uuid', nullable: true },
              celular: { type: 'string', nullable: true },
              celular_validado: { type: 'boolean', nullable: true },
              email: { type: 'string', nullable: true },
              email_validado: { type: 'boolean', nullable: true },
              active: { type: 'boolean', nullable: true },
              produccion: { type: 'boolean', nullable: true },
              kude_personalizado: { type: 'boolean', nullable: true },
              estado_id: { type: 'string', format: 'uuid', nullable: true },
              created_at: { type: 'string', format: 'date-time', nullable: true },
              updated_at: { type: 'string', format: 'date-time', nullable: true },
              usuario: { type: 'string', nullable: true },
            },
          },
          indicador_presencia: {
            type: 'object',
            nullable: true,
            properties: {
              id: { type: 'string', format: 'uuid' },
              codigo: { type: 'number' },
              descripcion: { type: 'string', nullable: true },
              created_at: { type: 'string', format: 'date-time', nullable: true },
              updated_at: { type: 'string', format: 'date-time', nullable: true },
              usuario: { type: 'string', nullable: true },
            },
          },
          moneda: {
            type: 'object',
            nullable: true,
            properties: {
              id: { type: 'string', format: 'uuid' },
              codigo: { type: 'string' },
              descripcion: { type: 'string', nullable: true },
              decimales: { type: 'string', nullable: true },
              created_at: { type: 'string', format: 'date-time', nullable: true },
              updated_at: { type: 'string', format: 'date-time', nullable: true },
              usuario: { type: 'string', nullable: true },
            },
          },
          suscripciones: { type: 'object', nullable: true },
          tipo_impuesto: {
            type: 'object',
            nullable: true,
            properties: {
              id: { type: 'string', format: 'uuid' },
              codigo: { type: 'number' },
              descripcion: { type: 'string', nullable: true },
              created_at: { type: 'string', format: 'date-time', nullable: true },
              updated_at: { type: 'string', format: 'date-time', nullable: true },
              usuario: { type: 'string', nullable: true },
            },
          },
          tipo_operacion: { type: 'object', nullable: true },
          tipo_transaccion: {
            type: 'object',
            nullable: true,
            properties: {
              id: { type: 'string', format: 'uuid' },
              codigo: { type: 'number' },
              descripcion: { type: 'string', nullable: true },
              created_at: { type: 'string', format: 'date-time', nullable: true },
              updated_at: { type: 'string', format: 'date-time', nullable: true },
              usuario: { type: 'string', nullable: true },
            },
          },
          factura_cuotas: { type: 'array', items: { type: 'object' } },
          factura_det: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: { type: 'string', format: 'uuid' },
                factura_cab_id: { type: 'string', format: 'uuid' },
                producto_id: { type: 'string', format: 'uuid' },
                ddesproser: { type: 'string', nullable: true },
                cunimed: { type: 'string', nullable: true },
                dcantproser: { type: 'number', nullable: true },
                cpaisorig: { type: 'string', nullable: true },
                dinfitem: { type: 'string', nullable: true },
                dcdcanticipo: { type: 'string', format: 'uuid', nullable: true },
                duniproser: { type: 'number', nullable: true },
                dticamit: { type: 'number', nullable: true },
                dtotbruopeitem: { type: 'number', nullable: true },
                ddescitem: { type: 'number', nullable: true },
                dporcdesit: { type: 'number', nullable: true },
                ddescgloitem: { type: 'number', nullable: true },
                dantpreuniit: { type: 'number', nullable: true },
                dantglopreuniit: { type: 'number', nullable: true },
                dtotopeitem: { type: 'number', nullable: true },
                dtotopegs: { type: 'number', nullable: true },
                iafeciva: { type: 'number', nullable: true },
                dpropiva: { type: 'number', nullable: true },
                dtasiva: { type: 'number', nullable: true },
                dbasgraviva: { type: 'number', nullable: true },
                dliqivaitem: { type: 'number', nullable: true },
                dbasexe: { type: 'number', nullable: true },
                item: { type: 'number', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
              },
            },
          },
          factura_forma_pagos: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: { type: 'string', format: 'uuid' },
                factura_cab_id: { type: 'string', format: 'uuid' },
                empresa_id: { type: 'string', format: 'uuid', nullable: true },
                sesion_caja_id: { type: 'string', format: 'uuid', nullable: true },
                medio_pago_id: { type: 'string', format: 'uuid', nullable: true },
                tarjeta_id: { type: 'string', format: 'uuid', nullable: true },
                forma_procesamiento_pago_id: { type: 'string', format: 'uuid', nullable: true },
                dmontipag: { type: 'number', nullable: true },
                cmonetipag: { type: 'string', nullable: true },
                dticamtipag: { type: 'number', nullable: true },
                drsprotar: { type: 'string', nullable: true },
                drucprotar: { type: 'string', nullable: true },
                ddvprotar: { type: 'number', nullable: true },
                dcodauope: { type: 'number', nullable: true },
                dnomtit: { type: 'string', nullable: true },
                dnumtarj: { type: 'string', nullable: true },
                ddesdentarj: { type: 'string', nullable: true },
                dnumcheq: { type: 'string', nullable: true },
                dbcoemi: { type: 'string', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
              },
            },
          },
          factura_subtotales: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: { type: 'string', format: 'uuid' },
                factura_cab_id: { type: 'string', format: 'uuid' },
                dsubexe: { type: 'number', nullable: true },
                dsubexo: { type: 'number', nullable: true },
                dsub5: { type: 'number', nullable: true },
                dsub10: { type: 'number', nullable: true },
                dtotope: { type: 'number' },
                dtotdesc: { type: 'number', nullable: true },
                dtotdescglotem: { type: 'number', nullable: true },
                dtotantitem: { type: 'number', nullable: true },
                dtotant: { type: 'number', nullable: true },
                dporcdesctotal: { type: 'number', nullable: true },
                danticipo: { type: 'number', nullable: true },
                dredon: { type: 'number', nullable: true },
                dcomi: { type: 'number', nullable: true },
                dtotgralope: { type: 'number', nullable: true },
                diva5: { type: 'number', nullable: true },
                diva10: { type: 'number', nullable: true },
                dliqtotiva5: { type: 'number', nullable: true },
                dliqtotiva10: { type: 'number', nullable: true },
                divacomi: { type: 'number', nullable: true },
                dtotiva: { type: 'number', nullable: true },
                dbasegrav5: { type: 'number', nullable: true },
                dbasegrav10: { type: 'number', nullable: true },
                dtbasgraiva: { type: 'number', nullable: true },
                dtotalgs: { type: 'number', nullable: true },
                ddesctotal: { type: 'number', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
              },
            },
          },
        },
      },
    },
  },
};
export const response_factura_create = {
  descripcion: 'Factura creada exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string' },
    },
  },
};

export const response_factura_siguiente_numeracion = {
  descripcion: 'Siguiente numeración obtenida exitosamente',
  schema: {
    type: 'object',
    properties: {
      siguiente: { type: 'string' },
      ultimo: { type: 'string' },
    },
  },
};

export const response_factura_all = {
  descripcion: 'Facturas obtenidas exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string' },
      data: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: { type: 'string', format: 'uuid' },
            empresa_id: { type: 'string', format: 'uuid' },
            cliente_id: { type: 'string', format: 'uuid' },
            tipo_transaccion_id: { type: 'string', format: 'uuid', nullable: true },
            tipo_impuesto_id: { type: 'string', format: 'uuid', nullable: true },
            moneda_id: { type: 'string', format: 'uuid', nullable: true },
            indicador_presencia_id: { type: 'string', format: 'uuid', nullable: true },
            condicion_operacion_id: { type: 'string', format: 'uuid', nullable: true },
            tipo_operacion_id: { type: 'string', format: 'uuid', nullable: true },
            sucripcion_id: { type: 'string', format: 'uuid', nullable: true },
            dinfoemi: { type: 'string', nullable: true },
            dinfofisc: { type: 'string', nullable: true },
            dest: { type: 'string' },
            dpunexp: { type: 'string' },
            dnumdoc: { type: 'string' },
            dserienum: { type: 'string', nullable: true },
            dfeemide: { type: 'string', format: 'date-time' },
            dcondticam: { type: 'string', nullable: true },
            dticam: { type: 'number', nullable: true },
            icondant: { type: 'string', nullable: true },
            dfecemnr: { type: 'string', format: 'date-time', nullable: true },
            demailadmin: { type: 'string', nullable: true },
            dmodcont: { type: 'string', nullable: true },
            dentcont: { type: 'number', nullable: true },
            danocont: { type: 'number', nullable: true },
            dseccont: { type: 'string', nullable: true },
            dfecodcont: { type: 'string', format: 'date-time', nullable: true },
            dciclo: { type: 'string', nullable: true },
            dfecinic: { type: 'string', format: 'date-time', nullable: true },
            dfecfinc: { type: 'string', format: 'date-time', nullable: true },
            dvencpag: { type: 'string', format: 'date-time', nullable: true },
            dcontrato: { type: 'string', format: 'date-time', nullable: true },
            dsalant: { type: 'number', nullable: true },
            dinfadic: { type: 'string', nullable: true },
            icondcred: { type: 'number', nullable: true },
            dplazocre: { type: 'string', nullable: true },
            dcuotas: { type: 'number', nullable: true },
            dmonent: { type: 'number', nullable: true },
            estado: { type: 'string' },
            documentos_asociados: { type: 'object', nullable: true },
            created_at: { type: 'string', format: 'date-time', nullable: true },
            updated_at: { type: 'string', format: 'date-time', nullable: true },
            usuario: { type: 'string', nullable: true },
            cuentas_cobrar: { type: 'array', items: { type: 'object' } },
            clientes: {
              type: 'object',
              nullable: true,
              properties: {
                id: { type: 'string', format: 'uuid' },
                persona_id: { type: 'string', format: 'uuid' },
                tipo_operacion_id: { type: 'string', format: 'uuid' },
                nombre_fantasia: { type: 'string', nullable: true },
                cod_cliente: { type: 'string', nullable: true },
                active: { type: 'boolean' },
                deleted: { type: 'boolean' },
                deleted_at: { type: 'string', format: 'date-time', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
                personas: {
                  type: 'object',
                  nullable: true,
                  properties: {
                    id: { type: 'string', format: 'uuid' },
                    empresa_id: { type: 'string', format: 'uuid', nullable: true },
                    tipo_documento_id: { type: 'string', format: 'uuid', nullable: true },
                    ciudad_id: { type: 'string', format: 'uuid', nullable: true },
                    naturaleza_id: { type: 'string', format: 'uuid', nullable: true },
                    tipo_contribuyente_id: { type: 'string', format: 'uuid', nullable: true },
                    razon_social: { type: 'string', nullable: true },
                    direccion: { type: 'string', nullable: true },
                    nro_casa: { type: 'number', nullable: true },
                    telefono: { type: 'string', nullable: true },
                    celular: { type: 'string', nullable: true },
                    email: { type: 'string', nullable: true },
                    ruc: { type: 'string', nullable: true },
                    dv: { type: 'string', nullable: true },
                    nro_documento: { type: 'string', nullable: true },
                    otro_tipo_documento: { type: 'string', nullable: true },
                    email_copia: { type: 'string', nullable: true },
                    email_adicional: { type: 'string', nullable: true },
                    active: { type: 'boolean', nullable: true },
                    deleted: { type: 'boolean', nullable: true },
                    deleted_at: { type: 'string', format: 'date-time', nullable: true },
                    estado: { type: 'string', nullable: true },
                    created_at: { type: 'string', format: 'date-time', nullable: true },
                    updated_at: { type: 'string', format: 'date-time', nullable: true },
                    usuario: { type: 'string', nullable: true },
                  },
                },
              },
            },
            condicion_operacion: {
              type: 'object',
              nullable: true,
              properties: {
                id: { type: 'string', format: 'uuid' },
                codigo: { type: 'number' },
                descripcion: { type: 'string', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
              },
            },
            empresas: {
              type: 'object',
              nullable: true,
              properties: {
                id: { type: 'string', format: 'uuid' },
                ruc: { type: 'string' },
                dv: { type: 'string' },
                razon_social: { type: 'string', nullable: true },
                nombre_fantasia: { type: 'string', nullable: true },
                tipo_contribuyente: { type: 'string', format: 'uuid', nullable: true },
                type: { type: 'string', nullable: true },
                parent_id: { type: 'string', format: 'uuid', nullable: true },
                celular: { type: 'string', nullable: true },
                celular_validado: { type: 'boolean', nullable: true },
                email: { type: 'string', nullable: true },
                email_validado: { type: 'boolean', nullable: true },
                active: { type: 'boolean', nullable: true },
                produccion: { type: 'boolean', nullable: true },
                kude_personalizado: { type: 'boolean', nullable: true },
                estado_id: { type: 'string', format: 'uuid', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
              },
            },
            indicador_presencia: {
              type: 'object',
              nullable: true,
              properties: {
                id: { type: 'string', format: 'uuid' },
                codigo: { type: 'number' },
                descripcion: { type: 'string', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
              },
            },
            moneda: {
              type: 'object',
              nullable: true,
              properties: {
                id: { type: 'string', format: 'uuid' },
                codigo: { type: 'string' },
                descripcion: { type: 'string', nullable: true },
                decimales: { type: 'string', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
              },
            },
            suscripciones: { type: 'object', nullable: true },
            tipo_impuesto: {
              type: 'object',
              nullable: true,
              properties: {
                id: { type: 'string', format: 'uuid' },
                codigo: { type: 'number' },
                descripcion: { type: 'string', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
              },
            },
            tipo_operacion: { type: 'object', nullable: true },
            tipo_transaccion: {
              type: 'object',
              nullable: true,
              properties: {
                id: { type: 'string', format: 'uuid' },
                codigo: { type: 'number' },
                descripcion: { type: 'string', nullable: true },
                created_at: { type: 'string', format: 'date-time', nullable: true },
                updated_at: { type: 'string', format: 'date-time', nullable: true },
                usuario: { type: 'string', nullable: true },
              },
            },
            factura_cuotas: { type: 'array', items: { type: 'object' } },
            factura_det: {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  id: { type: 'string', format: 'uuid' },
                  factura_cab_id: { type: 'string', format: 'uuid' },
                  producto_id: { type: 'string', format: 'uuid' },
                  ddesproser: { type: 'string', nullable: true },
                  cunimed: { type: 'string', nullable: true },
                  dcantproser: { type: 'number', nullable: true },
                  cpaisorig: { type: 'string', nullable: true },
                  dinfitem: { type: 'string', nullable: true },
                  dcdcanticipo: { type: 'string', format: 'uuid', nullable: true },
                  duniproser: { type: 'number', nullable: true },
                  dticamit: { type: 'number', nullable: true },
                  dtotbruopeitem: { type: 'number', nullable: true },
                  ddescitem: { type: 'number', nullable: true },
                  dporcdesit: { type: 'number', nullable: true },
                  ddescgloitem: { type: 'number', nullable: true },
                  dantpreuniit: { type: 'number', nullable: true },
                  dantglopreuniit: { type: 'number', nullable: true },
                  dtotopeitem: { type: 'number', nullable: true },
                  dtotopegs: { type: 'number', nullable: true },
                  iafeciva: { type: 'number', nullable: true },
                  dpropiva: { type: 'number', nullable: true },
                  dtasiva: { type: 'number', nullable: true },
                  dbasgraviva: { type: 'number', nullable: true },
                  dliqivaitem: { type: 'number', nullable: true },
                  dbasexe: { type: 'number', nullable: true },
                  item: { type: 'number', nullable: true },
                  created_at: { type: 'string', format: 'date-time', nullable: true },
                  updated_at: { type: 'string', format: 'date-time', nullable: true },
                  usuario: { type: 'string', nullable: true },
                },
              },
            },
            factura_forma_pagos: {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  id: { type: 'string', format: 'uuid' },
                  factura_cab_id: { type: 'string', format: 'uuid' },
                  empresa_id: { type: 'string', format: 'uuid', nullable: true },
                  sesion_caja_id: { type: 'string', format: 'uuid', nullable: true },
                  medio_pago_id: { type: 'string', format: 'uuid', nullable: true },
                  tarjeta_id: { type: 'string', format: 'uuid', nullable: true },
                  forma_procesamiento_pago_id: { type: 'string', format: 'uuid', nullable: true },
                  dmontipag: { type: 'number', nullable: true },
                  cmonetipag: { type: 'string', nullable: true },
                  dticamtipag: { type: 'number', nullable: true },
                  drsprotar: { type: 'string', nullable: true },
                  drucprotar: { type: 'string', nullable: true },
                  ddvprotar: { type: 'number', nullable: true },
                  dcodauope: { type: 'number', nullable: true },
                  dnomtit: { type: 'string', nullable: true },
                  dnumtarj: { type: 'string', nullable: true },
                  ddesdentarj: { type: 'string', nullable: true },
                  dnumcheq: { type: 'string', nullable: true },
                  dbcoemi: { type: 'string', nullable: true },
                  created_at: { type: 'string', format: 'date-time', nullable: true },
                  updated_at: { type: 'string', format: 'date-time', nullable: true },
                  usuario: { type: 'string', nullable: true },
                },
              },
            },
            factura_subtotales: {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  id: { type: 'string', format: 'uuid' },
                  factura_cab_id: { type: 'string', format: 'uuid' },
                  dsubexe: { type: 'number', nullable: true },
                  dsubexo: { type: 'number', nullable: true },
                  dsub5: { type: 'number', nullable: true },
                  dsub10: { type: 'number', nullable: true },
                  dtotope: { type: 'number' },
                  dtotdesc: { type: 'number', nullable: true },
                  dtotdescglotem: { type: 'number', nullable: true },
                  dtotantitem: { type: 'number', nullable: true },
                  dtotant: { type: 'number', nullable: true },
                  dporcdesctotal: { type: 'number', nullable: true },
                  danticipo: { type: 'number', nullable: true },
                  dredon: { type: 'number', nullable: true },
                  dcomi: { type: 'number', nullable: true },
                  dtotgralope: { type: 'number', nullable: true },
                  diva5: { type: 'number', nullable: true },
                  diva10: { type: 'number', nullable: true },
                  dliqtotiva5: { type: 'number', nullable: true },
                  dliqtotiva10: { type: 'number', nullable: true },
                  divacomi: { type: 'number', nullable: true },
                  dtotiva: { type: 'number', nullable: true },
                  dbasegrav5: { type: 'number', nullable: true },
                  dbasegrav10: { type: 'number', nullable: true },
                  dtbasgraiva: { type: 'number', nullable: true },
                  dtotalgs: { type: 'number', nullable: true },
                  ddesctotal: { type: 'number', nullable: true },
                  created_at: { type: 'string', format: 'date-time', nullable: true },
                  updated_at: { type: 'string', format: 'date-time', nullable: true },
                  usuario: { type: 'string', nullable: true },
                },
              },
            },
          },
        },
      },
      total: { type: 'number' },
      page: { type: 'number' },
      limit: { type: 'number' },
      lastPage: { type: 'number' },
    },
  },
};
